import { FC } from "react";

import { NO_VALUE_DISPLAY, onActivateKeyDown } from "@ryde/shared";

interface IBookingStationProps {
  stationId?: number;
  stationName?: string;
  canEdit: boolean;
  onStationClick: (stationId: number) => void;
}

export const BookingStation: FC<IBookingStationProps> = ({
  stationId,
  stationName,
  canEdit,
  onStationClick,
}) => {
  if (!stationId) {
    return <span>{NO_VALUE_DISPLAY}</span>;
  }

  const displayName = stationName || `#${stationId}`;

  if (canEdit) {
    return (
      <span
        className="course-schedule__station course-schedule__station--clickable"
        onClick={() => onStationClick(stationId)}
        onKeyDown={onActivateKeyDown(() => onStationClick(stationId))}
        role="button"
        tabIndex={0}
      >
        {displayName}
      </span>
    );
  }

  return <span className="course-schedule__station">{displayName}</span>;
};
